import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
//import { Http, Headers, RequestOptions } from '@angular/common/http';



import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BaseRequestOptions, RequestOptions, Headers, RequestOptionsArgs} from "@angular/http";

import { Storage } from '@ionic/storage';
import { ImagePicker } from '@ionic-native/image-picker';
import { Base64 } from '@ionic-native/base64';
import { File } from '@ionic-native/file';
import { Transfer, TransferObject } from '@ionic-native/transfer';
import { FilePath } from '@ionic-native/file-path';
import { Camera } from '@ionic-native/camera';

import { LoginPage } from '../login/login';
import { VisitorsRegPage } from '../visitors-reg/visitors-reg';

declare var cordova: any;

@Component({
  selector: 'page-startup',
  templateUrl: 'startup.html'
})
export class StartUpPage {
  constructor( 
      private formBuilder: FormBuilder,  
      public navCtrl: NavController, 
      private toastCtrl: ToastController, 
      public navParams: NavParams,     
      public http: HttpClient,    
      private imagePicker: ImagePicker,    
      private base64: Base64,
      private camera: Camera, 
      private transfer: Transfer, 
      private file: File, 
      private filePath: FilePath, 
      public actionSheetCtrl: ActionSheetController, 
      public platform: Platform, 
      public loadingCtrl: LoadingController ,
      private storage: Storage
    ) {
      //storage.set('authtoken', '28');
       
        
      }
}



// WEBPACK FOOTER //
// ./src/pages/startup/startup.ts